<template>
  <div>
    <ul class=" main-container list-group" @click="changeActive(projectName)">
      <li
        :class="{ selected: activeId === projectName }"
        class="list-group-item d-flex justify-content-between align-items-center mt-2"
      >
        <div v-if="activeId === projectName" class="card-tip"></div>
        <div class="plot-farm-name">
          <p>{{ index + 1 }}. {{ projectName }}</p>
        </div>
        <div
          class="links-wrapper d-flex justify-content-between align-items-center"
        >
          <span class="badge  rounded-pill"
            ><i class="bi bi-github fs-6" style="color:black"></i
          ></span>
          <a :href="hostedLink" target="_blank">
            <span class="badge  rounded-pill mx-2"
              ><i style="color:black" class="bi bi-box-arrow-up-right"></i
            ></span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ProjectNameComponent",
  props: {
    projectName: String,
    activeId: String,
    index: Number,
    isSearching: Boolean,
    hostedLink: String
  },
  data() {
    return {
      sensorArray: []
    };
  },
  methods: {
    changeActive(identifier) {
      this.$emit("changeActive", { id: identifier });
    }
  }
};
</script>

<style scoped>
.selected {
  background-color: #2a9d8f;
  color: whitesmoke;
}
.main-container li {
  width: 97%;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.09);
  cursor: pointer;
}
.card-tip {
  height: 20px;
  width: 20px;
  position: absolute;
  right: -10px;
  top: calc(50% - 8px);
  transform: rotate(45deg);
  background-color: #2a9d8f;
}
li:hover {
  /* background-color: #b1d6c8; */
  background-color: #98d5be;
  border: 1px solid #98d5be;
}
.selected:hover {
  background-color: #2a9d8f;
  border: 1px solid #2a9d8f;
}
.main-container:hover .model-count {
  background: rgba(255, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectNameCard.vue